import type { FieldDef } from '../../types'
import { CreateEntityPage } from '../CreateEntityPage/CreateEntityPage'
import { createTenantGroup } from '../../services/api/createTenantGroup'

const fields: FieldDef[] = [
  { name: 'code', label: 'Code', type: 'text' },
  { name: 'name', label: 'Name', type: 'text' },
  { name: 'type', label: 'Type', type: 'text' },
  { name: 'availabilityBuildEnabled', label: 'Enable Availability Build', type: 'checkbox', defaultValue: true },
]

export function CreateTenantGroupPage() {
  return (
    <CreateEntityPage
      title="Create Tenant Group"
      backTo="/tenant-groups"
      fields={fields}
      createFn={createTenantGroup}
    />
  )
}
